<template>
  <div class="orm-datepicker orm-w100" v-click-outside="handleClick">
    <div class="orm-w100">
      <div
        class="orm-searchbar__headline"
        v-if="viewType !== 'infobar' && viewType !== 'abopicker'"
      >
        <strong>{{ i18n("general/abotime") || "Abo-Beginn" }}</strong>
      </div>
      <div
        class="orm-dateselect orm-row no-margin"
        v-if="viewType !== 'abopicker'"
      >
        <div class="orm-px-8 orm-w100 orm-flex middle-xs center-xs start-sm">
          <div
            class="orm-datepicker__input orm-pr-16 orm-w100"
            @click="!readonly ? (changeDate = 'start') : ''"
            id="start"
            :class="[
              changeDate == 'start' ? 'active' : '',
              station ? 'enable' : 'disable',
            ]"
          >
            {{
              formateDateDayLong(
                store.getters["userSession/GET_RESERVATIONDATE"].start
              )
            }}
            <i class="fal fa-calendar-alt right-0"></i>
          </div>
        </div>
      </div>
      <div
        v-else
        @click="!readonly ? (changeDate = 'start') : ''"
        class="orm-datepicker__abo_button"
      >
        <i class="fal fa-calendar-alt orm-mr-8"></i> Wähle den Abo-Beginn
      </div>
    </div>
    <VDaySelector
      class="orm-singleselect"
      v-if="changeDate"
      v-model:selected-date="
        store.getters['userSession/GET_RESERVATIONDATE'].start
      "
      v-model:changeDate="changeDate"
      :default-date="store.getters['userSession/GET_RESERVATIONDATE'].start"
      :teleportTo="vDatepickerTeleport"
      :disabled-dates="disabledDates"
      :min-date="minDate"
      :max-date="maxDate"
      :disabledWeekdays="disabledWeekdays"
      :singleMonth="true"
      :lang="lang"
      max-month-start="0"
      max-month-end="24"
      @update:startDate="changeStart"
    />
  </div>
</template>

<script>
// import VRangeSelector from "vuelendar/components/vl-range-selector";
import VDaySelector from "@/components/vuelendar/vl-day-selector";
import store from "@/store";
import i18n from "@/mixins/mixins";

import {
  formateDate,
  formatDayOfWeek,
  formateDateShort,
  formateDateDayLong,
} from "@/constants/formater";

export default {
  components: {
    // VRangeSelector,
    VDaySelector,
  },
  mixins: [i18n],
  emits: ["update:date"],
  setup() {
    return {
      formateDateShort,
      formatDayOfWeek,
      formateDateDayLong,
      store,
    };
  },
  data() {
    return {
      range: Object,
      pickerRange: Object,
      date: null,
      minDate: null,
      maxDate: null,
      station: null,
      disabledDates: [],
      disabledWeekdays: [],
      schedule: null,
      changeDate: null,
      openingStartMin: null,
      openingEndMin: null,
      openingSelctedStart: null,
      openingSelctedEnd: null,
      endtimeconfig: null,
      starttimeconfig: null,
      lang: "DE",
    };
  },
  props: {
    viewType: String,
    vDatepickerTeleport: String,
    infobar: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    maxdate: {
      type: String,
      default: null,
    },
  },
  async mounted() {
    const crentReservation = document.getElementById("crentReservation");
    if (crentReservation) {
      if (crentReservation.dataset) {
        if (crentReservation.dataset.lang) {
          this.lang = crentReservation.dataset.lang;
        }
      }
    }

    await store.dispatch("stations/SET_OPENINGTIMES");
    this.range = await store.getters["userSession/GET_RESERVATIONDATE"];
    this.initStartEndDate();

    const station = await store.getters["userSession/GET_STATION"];
    this.disabledDates = store.getters["stations/GET_CLOSEDDAYS"];

    if (station) {
      this.station = await store.getters["stations/GET_STATION_BY_ID"](station);
    }

    if (process.env.VUE_APP_PLZ === "true") {
      this.station = [];
    }

    store.watch(
      (getters) => getters["userSession/GET_STATION"],
      (val) => {
        this.station = store.getters["stations/GET_STATION_BY_ID"](val);
        this.initStartEndDate();
      }
    );
  },
  methods: {
    handleClick(ev) {
      if (!ev.target.classList.contains("vl-calendar__arrow")) {
        this.changeDate = null;
      }
    },
    changeStart(event) {
      this.pickerRange.start = event;
      store.commit("userSession/MUTATE_DATE", this.pickerRange);
      this.range = store.getters["userSession/GET_RESERVATIONDATE"];

      store.dispatch("stations/SET_OPENINGTIMES").then(() => {
        this.setOpeneningTimes();
        this.$emit("update:date");
      });
    },
    changeEnd(event) {
      this.pickerRange.end = event;
      store.commit("userSession/MUTATE_DATE", this.pickerRange);
      this.range = store.getters["userSession/GET_RESERVATIONDATE"];
      store.dispatch("stations/SET_OPENINGTIMES").then(() => {
        this.setOpeneningTimes();
      });
    },
    // eslint-disable-next-line
    initStartEndDate() {
      this.setOpeneningTimes();
    },
    async setOpeneningTimes() {
      const openeningTimes = await store.getters["stations/GET_OPENINGTIMES"];
      this.schedule = openeningTimes;

      this.range = await store.getters["userSession/GET_RESERVATIONDATE"];
      this.pickerRange = { start: this.range.start, end: this.range.end };

      if (openeningTimes) {
        this.openingSelctedStart = openeningTimes.selected_start_date.split(
          "T"
        );
        this.openingSelctedEnd = openeningTimes.selected_end_date.split("T");
        this.openingStartMin = openeningTimes.min_start_date.split("T");
        this.openingEndMin = openeningTimes.min_end_date.split("T");
        this.minDate = formateDate(openeningTimes.min_start_date);
        this.maxDate = this.maxdate || formateDate(openeningTimes.max_start_date);
        this.endtimeconfig = openeningTimes.end_time_config;
        this.starttimeconfig = openeningTimes.start_time_config;
      }
    },
  },
};
</script>
